import {useMutation} from "@tanstack/react-query";
import {updateUserType} from "../services/UserTypeService";

export function useUserTypeUpdate() {
    return useMutation({
        mutationFn: ({id, payload}) => updateUserType(id, payload),
    });
}
